
export const kLOCALES = ['de', 'en', 'fr', 'cz'];
export const kDEFAULT_LOCALE = 'en';
